module.exports = __webpack_public_path__ + "img/TaktvsVTAF.d3fea958.png";